import ProductModel from './ProductModel';

const RecipeModel = {
    initModel: {
        id: 0,
        title: '',
        recipeText: '',
        productsList: [
            {
                product: ProductModel,
                amountGross: 0,
                amountNet: 0,
                amountGrossCradle: 0,
                amountNetCradle: 0,
                carbohydrates: 0,
                proteins: 0,
                fat: 0,
                energyValueKcal: 0,
                carbohydratesCradle: 0,
                proteinsCradle: 0,
                fatCradle: 0,
                energyValueKcalCradle: 0,
            },
        ],
        allProteinsCradle: 0,
        allProteins: 0,
        allFatCradle: 0,
        allFat: 0,
        allEnergyValueKcalCradle: 0,
        allEnergyValueKcal: 0,
        allCarbohydratesCradle: 0,
        allCarbohydrates: 0,
    },
    fieldNames: [
        'title',
        'recipeText',
    ],
    fieldsTypes: [
        'text',
        'text',
    ]
};

export default RecipeModel;
